import {
  EDIT_USER,
  EDIT_CONNECTION,
  NEW_CONNECTION,
  FETCH_CONNECTION,
  FETCH_CONNECTIONS,
  FETCH_TAG,
  FETCH_TAGS,
  EDIT_TAG,
  FETCH_USER,
  FETCH_USERS,
  INCREMENT,
  LOAD_CONNECTION_LIST,
  SENT_EMAIL_SUCCESS, SET_PROGRESS_BAR, ADD_MIND_BODY_CONNECTION
} from "./actionTypes";
import axios from "axios";
import {receiveErrors} from "./error";
import {toast} from "react-toastify";
import history from "../history";
import {
  parseDateTime
} from "../util/utils"

// import {sleep} from "../util/utils";

export const toastToSuccessAction = (message) => {
  return function (dispatch) {
    dispatch({
      type: INCREMENT
    });
    toast.success(message);
  };
};

export const toastToFailureAction = (message) => {
  return function (dispatch) {
    dispatch({
      type: INCREMENT
    });
    toast.error(message);
  };
};

export const fetchConnectionList = async (callback) => {
  await axios({
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    method: 'post',
    url: '/api/v1/connections/getConnectionsWithLinks'
  }).then(response => {
    callback(response.data.connections);
  })
    .catch(err => console.log(err.response));
};

export const fetchUsers = () => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: '/api/v1/users'
    }).then(response => {
      // Convert the time and date to the users local format
      response.data.users.forEach(function(part, index) {
        this[index]["createdAt"] = parseDateTime(this[index]["createdAt"]);
        this[index]["updatedAt"] = parseDateTime(this[index]["updatedAt"]);
      }, response.data.users);
      dispatch({type: FETCH_USERS, payload: response.data.users});
      dispatch({type: FETCH_USER, payload: {}});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const fetchUser = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: `/api/v1/users/${id}`
    }).then(response => {
      dispatch({type: FETCH_USER, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const fetchUserWithConnections = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: `/api/v1/users/details/${id}`
    }).then(response => {
      dispatch({type: FETCH_USER, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};


export const fetchConnections = () => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: '/api/v1/connections/getConnectionsWithLinks'
    }).then(response => {
      response.data.connections.forEach(function(part, index) {
        this[index]["createdAt"] = parseDateTime(this[index]["createdAt"]);
        this[index]["updatedAt"] = parseDateTime(this[index]["updatedAt"]);
      }, response.data.connections);
      dispatch({type: FETCH_CONNECTIONS, payload: response.data.connections});
      dispatch({type: FETCH_CONNECTION, payload: {}});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const fetchConnection = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: `/api/v1/connections/${id}`
    }).then(response => {
      dispatch({type: FETCH_CONNECTION, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const editConnection = (id, formValues) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data: formValues,
      method: 'patch',
      url: `/api/v1/connections/${id}`
    }).then(response => {
      dispatch({type: EDIT_CONNECTION, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully edited connection!"));
      history.push('/dashboard/admin/connections')
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to edit connection!"));
        console.log("Got error");
        console.log(err.response)
      });
  }
};

export const removeUserConnections = (id, userConnectionIds) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data: {ids: userConnectionIds},
      method: 'delete',
      url: `/api/v1/userConnections/${id}`
    }).then(response => {
      console.log(response);
      dispatch(fetchUserWithConnections(id));
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch({ type: ADD_MIND_BODY_CONNECTION, payload: response.data.connections });
      dispatch(toastToSuccessAction("Successfully removed users connection(s)!"));
      // history.push('/dashboard/admin/connections')
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to remove users connection!"));
        console.log(err.response)
      });
  }
};

export const newConnection = (formValues) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data: formValues,
      method: 'post',
      url: `/api/v1/connections/createConnection`
    }).then(response => {
      dispatch({type: NEW_CONNECTION, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully created connection!"));
      history.push('/dashboard/admin/connections')
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to create connection!"));
        console.log(err.response)
      });
  }
};


export const sendEmail = (email) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      method: 'POST',
      url: '/api/v1/users/invite',
      data: {"email": email}
    })
      .then(() => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToSuccessAction("Successfully sent email"));
        dispatch({type: SENT_EMAIL_SUCCESS, payload: "Successfully sent email"})
      })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction(err.response.data.message));
        return dispatch(receiveErrors(err.response.data.message));
      });
  };
};

export const sendConnectionRequestEmail = (formValues) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      method: 'POST',
      url: '/api/v1/connections/connectionRequest',
      data: formValues
    })
      .then(() => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToSuccessAction("Successfully sent email"));
        dispatch({type: SENT_EMAIL_SUCCESS, payload: "Successfully sent email"})
        history.push('/dashboard/query')
      })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction(err.response.data.message));
        return dispatch(receiveErrors(err.response.data.message));
      });
  };
};

export const loadConnections = (connectionList) => ({
  type: LOAD_CONNECTION_LIST,
  payload: connectionList
});

export const editUser = (id, formValues) => {
  return async (dispatch) => {
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data: formValues,
      method: 'patch',
      url: `/api/v1/users/${id}`
    }).then(response => {
      dispatch({type: EDIT_USER, payload: response.data});
      dispatch(toastToSuccessAction("Successfully edited user!"));
      history.push('/dashboard/admin/users')
    })
      .catch(err => {
        dispatch(toastToFailureAction("Failed to edit user!"));
        console.log("Got error");
        console.log(err.response)
      });
  }
};

export const deleteUser = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'delete',
      url: `/api/v1/users/${id}`
    }).then(response => {
      // dispatch({type: DELETE_USER, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully deleted user!"));
      dispatch(fetchUsers());
      history.push('/dashboard/admin/users');
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to delete user!"));
        console.log(err.response);
        history.push('/dashboard/admin/users');
      });
  }
};

export const deleteConnection = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'delete',
      url: `/api/v1/connections/${id}`
    }).then(response => {
      // dispatch({type: DELETE_USER, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully deleted connection!"));
      dispatch(fetchConnections());
      history.push('/dashboard/admin/connections');
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to delete connection!"));
        console.log(err.response);
        history.push('/dashboard/admin/connections');
      });
  }
};

export const fetchTags = () => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: '/api/v1/tags'
    }).then(response => {
      response.data.tags.forEach(function(part, index) {
        this[index]["createdAt"] = parseDateTime(this[index]["createdAt"]);
        this[index]["updatedAt"] = parseDateTime(this[index]["updatedAt"]);
      }, response.data.tags);
      dispatch({type: FETCH_TAGS, payload: response.data.tags});
      dispatch({type: FETCH_TAG, payload: {}});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
    })
      .catch(err => {
        console.log(err.response)
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const fetchTag = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'get',
      url: `/api/v1/tags/${id}`
    }).then(response => {
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch({type: FETCH_TAG, payload: response.data});
    })
      .catch(err => {
        console.log(err.response);
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
      });
  }
};

export const editTag = (id, formValues) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data: formValues,
      method: 'patch',
      url: `/api/v1/tags/${id}`
    }).then(response => {
      dispatch({type: EDIT_TAG, payload: response.data});
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully edited tag!"));
      history.push('/dashboard/admin/tags')
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to edit tag!"));
      });
  }
};

export const deleteTag = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRESS_BAR, payload: true });
    await axios({
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'delete',
      url: `/api/v1/tags/${id}`
    }).then(response => {
      dispatch({ type: SET_PROGRESS_BAR, payload: false });
      dispatch(toastToSuccessAction("Successfully deleted tag!"));
      dispatch(fetchTags());
      history.push('/dashboard/admin/tags');
    })
      .catch(err => {
        dispatch({ type: SET_PROGRESS_BAR, payload: false });
        dispatch(toastToFailureAction("Failed to delete connection!"));
        history.push('/dashboard/admin/tags');
      });
  }
};


export const setProgressBar = (isOpen) => {
  return async (dispatch) => {
    dispatch({type: SET_PROGRESS_BAR, payload: isOpen});
  };
};




